var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common_search"},[_c('div',{staticClass:"inputRegion"},[_vm._t("inputRegion")],2),_c('div',{staticClass:"buttonBar"},[_vm._t("buttons")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }